// Version information - version will be injected at build time
// For now, fallback to reading from import.meta.env or default

const getEnvironment = () => {
  // Check if we're in production mode
  if (import.meta.env.PROD) {
    return 'production';
  }
  // Check NODE_ENV environment variable
  if (import.meta.env.VITE_NODE_ENV === 'production') {
    return 'production';
  }
  return import.meta.env.MODE || 'development';
};

export const VERSION_INFO = {
  version: import.meta.env.VITE_APP_VERSION || "0.0.36",
  gitHash: "unknown",
  gitShortHash: "unknown", 
  gitBranch: "unknown",
  commitDate: new Date().toISOString(),
  buildDate: new Date().toISOString(),
  isDirty: false,
  buildNumber: "local",
  environment: getEnvironment()
} as const;

export const getVersionString = () => {
  const { version, gitShortHash, isDirty } = VERSION_INFO;
  return gitShortHash === "unknown" ? `v${version}` : `v${version}-${gitShortHash}${isDirty ? '-dirty' : ''}`;
};

export const getBuildInfo = () => {
  const { buildDate, gitBranch, environment } = VERSION_INFO;
  return {
    buildDate: new Date(buildDate),
    branch: gitBranch,
    environment
  };
};
